import moment from 'moment-timezone';
import { timeFormat } from '../utilities/timeUtility';
import { capitalize } from '../utilities/stringtUtility';

const { dateFormat, timeZone } = window.bta;

export const getValue = ({ order, product: { data: product } }, item, key, isRental) => ({
  Date() {
    return moment.tz(item.start, timeZone).format(`${dateFormat}`);
  },
  Time() {
    return moment.tz(item.start, timeZone).format(`${timeFormat()}`).replace(/\s/g, '');
  },
  Start() {
    const format = isRental ? `${dateFormat}` : `${dateFormat} ${timeFormat()}`;
    return moment.tz(item.start, timeZone).format(format);
  },
  Finish() {
    const format = isRental ? `${dateFormat}` : `${dateFormat} ${timeFormat()}`;
    return moment.tz(item.finish, timeZone).format(format);
  },
  Term() {
    return order.termSelected.name;
  },
  Resource() {
    if (order.selectedResource === null) return null;
    return order.selectedResource.name;
  },
  _resource_ids() {
    if(order.selectedResource === null) return null;
    return order.selectedResource.id.toString();
  },
  Location() {
    if (order.selectedLocation === null) return null;
    return order.selectedLocation.name;
  },
  Duration() {
    return `\n${order.dateRange.duration} Days`;
  },
}[key]());

export const addItems = (_reservation, type = []) => (_dispatch, getState) => {
  const { onSubmit } = window.xprops;

  const state = getState(),
        settings = state.settings,
        isRental = settings.setting ? settings.setting.name == 'Rental' : false;

  const reservation = {
    ..._reservation,
    items: _reservation.items.map((item) => {
      const properties = {};

      type.forEach((_key) => {
        const key = capitalize(_key);
        properties[key] = getValue(state, item, key, isRental);
      });

      return {
        id: item.external_id,
        quantity: item.quantity,
        properties,
      };
    }),
  };

  return onSubmit(reservation);
};
